// ================= IMPORTS =================
import logogradient from "./assets/home_logo.png";
import logo from "./assets/home_logo.png";
import profile from "./assets/profile.png";

// import tailwind from "./assets/techstack/tailwind.png";
// import react from "./assets/techstack/react.png";
// import git from "./assets/techstack/git.png";
// import github from "./assets/techstack/github.png";
// import vscode from "./assets/techstack/vscode.png";

// import projectImage1 from "./assets/projects/project1.jpg";

// ================= CERTIFICATION LOGOS =================
import awsSAA from "./assets/certification-logo/aws-saa.png";
import gcpACE from "./assets/certification-logo/GCP-ACE.png";
import gcpDOPE from "./assets/certification-logo/GCP-DOPE.png";
import awsAI from "./assets/certification-logo/aws-ai.png";
import hcTerraform from "./assets/certification-logo/hcTerraform.png";

// Cloud logos
import aws from "./assets/cloud/aws.png";
import gcp from "./assets/cloud/gcp.jpg";
import azure from "./assets/cloud/azure.png";

// DevOps tools
import kubernetes from "./assets/devops/kubernetes.png";
import docker from "./assets/devops/docker.png";
import terraform from "./assets/devops/terraform.png";
import cloudformation from "./assets/devops/cloudformation.png";
import ansible from "./assets/devops/ansible.png";
import jenkins from "./assets/devops/jenkins.png";
import githubActions from "./assets/devops/github-actions.png";
import gitlabCI from "./assets/devops/gitlab.png";
import apache from "./assets/devops/apache.png";
import nginx from "./assets/devops/nginx.png";
import tomcat from "./assets/devops/tomcat.png";
// import zabbix from "./assets/devops/zabbix.png";
import elk from "./assets/devops/elk.png";
import grafana from "./assets/devops/grafana.png";

// Scripting
import python from "./assets/scripting/python.png";
import shell from "./assets/scripting/shell.png";
import json from "./assets/scripting/json.png";
import yaml from "./assets/scripting/yaml.png";

// Databases
import mongodb from "./assets/database/mongodb.png";
import mysql from "./assets/database/mysql.png";
import postgres from "./assets/database/postgres.png";
import redis from "./assets/database/redis.png";


// ================= LOGOS =================
export const logos = {
  logogradient,
  logo,
};

// ================= PERSONAL DETAILS =================
export const personalDetails = {
  name: "Shagun Dave",
  tagline: "DevOps Engineer | Cloud & Automation Specialist",
  img: profile,
  about: `I am a Senior Cloud / DevOps Engineer with extensive experience designing, architecting, and operating scalable, secure, and highly available cloud platforms. With a career spanning since 2016, I have led the architecture, automation, and optimization of mission-critical systems across hybrid and multi-cloud environments. My expertise spans AWS, Azure, Google Cloud Platform (GCP), Kubernetes, Istio, Docker, Jenkins, Linux, CloudFormation, networking, Python, and shell scripting. I specialize in building cloud-native architectures, implementing Infrastructure as Code, and designing resilient CI/CD pipelines that support rapid, reliable software delivery. I work at the intersection of architecture, operations, and engineering, collaborating closely with development and QA teams to align infrastructure design with application requirements. By integrating DevOps best practices and automation, I enable organizations to improve deployment velocity, system reliability, and operational efficiency. I am responsible for defining and managing infrastructure strategies for hybrid, multi-tenant platforms, including resource provisioning, deployment models, performance validation, and continuous monitoring. My approach emphasizes scalability, observability, security, and cost optimization, ensuring platforms are built for both current needs and future growth. I hold a Bachelor of Engineering in Electrical, Electronics, and Communications Engineering from SAL Institute of Technology & Engineering Research, and I am driven by a passion for designing robust cloud architectures that empower engineering teams and business outcomes.`,
};

// ================= SOCIAL LINKS =================
export const socialMediaUrl = {
  linkdein: "https://www.linkedin.com/in/shagun-dave-a71006b7/",
  github: "https://github.com/shagundave",
  twitter: "https://twitter.com/5ha9un",
};

// ================= EDUCATION =================
export const eduDetails = [
  {
    Position: "Bachelor of Engineering",
    Company: "SAL Institute of Technology & Engineering Research",
    Location: "Ahmedabad, India",
    Type: "Full Time",
    Duration: "2012 - 2016",
  },
];

// ================= WORK EXPERIENCE =================
export const workDetails = [
  {
    Position: "Sr. DevOps Engineer",
    Company: "Hexaware Technologies",
    Location: "India",
    Type: "Full Time",
    Duration: "Sept 2022 - Present",
  },
  {
    Position: "DevOps Engineer",
    Company: "Rapidops Inc",
    Location: "India",
    Type: "Full Time",
    Duration: "Oct 2019 - Sept 2022",
  },
  {
    Position: "DevOps Engineer",
    Company: "EvinceDev",
    Location: "India",
    Type: "Full Time",
    Duration: "Jun 2019 - Sept 2019",
  },
  {
    Position: "Associate DevOps Engineer",
    Company: "Codal Systems",
    Location: "India",
    Type: "Full Time",
    Duration: "Feb 2019 - May 2019",
  },
  {
    Position: "Cloud Engineer",
    Company: "Intuz Inc",
    Location: "India",
    Type: "Full Time",
    Duration: "July 2017 - Feb 2019",
  },
  {
    Position: "Cloud Trainee",
    Company: "Knowarth",
    Location: "India",
    Type: "Full Time",
    Duration: "Jan 2017 - Jun 2017",
  },
];

// ================= CONTACT =================
export const contactDetails = {
  email: "shagun.dave@yahoo.com",
};

// ================= CLOUD STACK =================
export const cloudStack = [
  { name: "AWS", image: aws },
  { name: "Google Cloud Platform", image: gcp },
  { name: "Microsoft Azure", image: azure },
];

// ================= DEVOPS TOOLS =================
export const devopsTools = [
  { name: "Kubernetes", image: kubernetes },
  { name: "Docker", image: docker },
  { name: "Terraform", image: terraform },
  { name: "AWS CloudFormation", image: cloudformation },
  { name: "Ansible", image: ansible },
  { name: "Jenkins", image: jenkins },
  { name: "GitHub Actions", image: githubActions },
  { name: "GitLab CI", image: gitlabCI },
  { name: "Apache", image: apache },
  { name: "Nginx", image: nginx },
  { name: "Tomcat", image: tomcat },
  // { name: "Zabbix", image: zabbix },
  { name: "ELK Stack", image: elk },
  { name: "Grafana", image: grafana },
];

// ================= SCRIPTING =================
export const scriptingLanguages = [
  { name: "Python", image: python },
  { name: "Shell Script", image: shell },
  { name: "JSON", image: json },
  { name: "YAML", image: yaml },
];

// ================= DATABASES =================
export const databases = [
  { name: "MongoDB", image: mongodb },
  { name: "MySQL", image: mysql },
  { name: "PostgreSQL", image: postgres },
  { name: "Redis", image: redis },
];

// ================= CERTIFICATIONS =================
export const certificationDetails = [
  {
    title: "AWS Certified Solutions Architect – Associate",
    issuer: "Amazon Web Services",
    image: awsSAA, 
    credentialLink: "#",
  },
  {
    title: "Google Cloud Associate Cloud Engineer",
    issuer: "Google Cloud",
    image: gcpACE,
    credentialLink: "#",
  },
  {
    title: "Google Cloud Professional DevOps Engineer",
    issuer: "Google Cloud",
    image: gcpDOPE,
    credentialLink: "#",
  },
  {
    title: "HarshiCorp Terraform Associate",
    issuer: "HashiCorp",
    image: hcTerraform,
    credentialLink: "https://www.credly.com/badges/c7aa8aa9-47c6-4dd8-9650-36d73eb17299/public_url",
  },
  {
    title: "AWS Certified AI Practitioner",
    issuer: "Amazon Web Services",
    image: awsAI,
    credentialLink: "https://www.credly.com/badges/9424901b-e76d-471f-90a8-6997a54c832e/public_url",
  },
];
